export default "__VITE_ASSET__35ed28b1__"